<template>
  <div class="login-page">
    <!-- <div class="logo"><img src="@/assets/image/logo.png" alt="" /></div> -->
    <div class="login-box">
      <div class="login-title"><img src="@/assets/image/login-logo.png"><br>京师壹心测评查询</div>
      <div class="login-form">
        <p></p>
        <el-input v-model="account" placeholder="请输入预留的手机号"></el-input>
        <el-button type="primary" class="login-btn" :loading="btnLoading" @click="checkFn">登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { APILOGIN } from '@/common/api.js'
import { setStorage, getStorage } from "@/common/storage"
export default {
  data() {
    return {
      account: '',
      btnLoading: false,
    }
  },
  methods: {
    checkFn() {
      if (this.account === '') {
        this.$message.error('账号不能为空')
        return false
      }
      this.submit()
    },
    submit() {
      this.btnLoading = true
      APILOGIN({
        mobile: this.account,
      }).then((res) => {
        setStorage('USERINFO', res.data)
        setStorage('token', res.data.token)

        this.$router.push({ path: '/archive' })
        // location.reload()
        this.btnLoading = false
      }).catch((err) => {
        this.btnLoading = false
        this.$message.error(err.msg)
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.login-page {
  height: 100%;
  padding: 1px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .logo {
    height: 36px;
    margin: 0 auto;
    padding-top: 60px;
    text-align: center;

    img {
      height: 36px;
    }
  }

  .login-box {
    width: 90%;
    max-width: 450px;
    height: 320px;
    // margin: 25% auto 0;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px 0px rgba(18, 150, 255, 0.3);
    border-radius: 10px;
    padding: 30px 10px 0;

    .login-title {
      height: 100px;
      border-bottom: 1px solid #e6e6e6;
      box-sizing: border-box;
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      line-height: 30px;
      position: relative;

      img {
        width: 30px;
      }
    }

    .login-form {
      padding: 0 40px;

      p {
        font-size: 16px;
        color: #17233d;
        line-height: 16px;
        margin-top: 30px;
      }

      .input {
        width: 100%;
        height: 44px;
        border-radius: 4px;
        border: 1px solid #4c5bf7;
        margin-top: 16px;
        box-sizing: border-box;
        padding: 5px 10px;
      }

      .login-btn {
        width: 100%;
        height: 44px;
        background: #4C5BF7;
        border-color: #4C5BF7;
        border-radius: 8px;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 40px;
      }
    }
  }
}
</style>
